export default __webpack_public_path__ + "static/media/message.1419a063.svg";